/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
import * as React from 'react'
import { List, Map } from 'immutable'
import { AsyncState, loadedAsyncState, any, stateful } from 'widgets-for-react'
import { CMSState, Id, ImageSize, Url } from '../../../Client/components/cms/blocks/types.gen'
import {
  ExtraImages,
  featuredblock_src,
  featuredblock_srcset,
  textimageblock_src,
  textimageblock_srcset,
  linkgridblock_src,
  linkgridblock_srcset,
  get_default_data_src,
  get_default_data_srcset,
  ctablock_src,
  ctablock_srcset,
  quoteblock_src,
  quoteblock_srcset,
  gallery_src,
  gallery_srcset
} from '../../../Client/components/public_site/utils/extra_images.mod'
import { blocks_renderer } from '../../../Client/components/public_site/blocks/renderer.mod'
import { renderBlock } from '../../../Client/components/cms/blocks/block_to_widget.gen'
import {
  textBlockClasses,
  downloadBlockClasses,
  linkGridBlockPlainClasses,
  linkGridBlockClasses,
  mediaBlockClasses,
  ctaBlockClasses,
  quoteBlockClasses,
  imageGalleryBlockClasses,
  linkListBlockClasses,
  expandBlockClasses,
  mediaBlockNestedClasses,
  textBlockNestedClasses,
  textImageClasses,
  quoteBlockNestedClasses
} from '../../../Client/components/public_site/blocks/style.mod'
import { GetCookiebarButton, GetCookiebarContent } from '../../components/drupal/rendering/cookiebar_utils.mod'
import { ListWithAtLeast3Items } from '../../components/cms/blocks/widgets/imageGalleryBlock.gen'

export const FakeCMSState: CMSState<never, ExtraImages, never> = {
  images: Map<Id, AsyncState<Map<ImageSize<ExtraImages>, Url>>>()
    .set(
      2,
      loadedAsyncState(
        Map<ImageSize<ExtraImages>, Url>()
          .set('640w', '/styleguide/images/640x360.png')
          .set('640x360', '/styleguide/images/640x360.png')
          .set('1280w', '/styleguide/images/1280x720.png')
          .set('1280x720', '/styleguide/images/1280x720.png')
          .set('1920w', '/styleguide/images/1920x1080.png')
          .set('2880w', '/styleguide/images/2880x1620.png')
      )
    )
    .set(
      3,
      loadedAsyncState(Map<ImageSize<ExtraImages>, Url>()
      .set('640x360', '/styleguide/images/640x360-reverse.png')
      .set('1280x720', '/styleguide/images/1280x720.png'))
    )
    .set(
      4,
      loadedAsyncState(
        Map<ImageSize<ExtraImages>, Url>()
          .set('640w', '/styleguide/images/640x960.png')
          .set('1280w', '/styleguide/images/1280x1920.png')
          .set('1920w', '/styleguide/images/1920x2880.png')
          .set('2880w', '/styleguide/images/2880x4320.png')
      )
    ),
  blocks: Map<any, any>().set(13, {
    kind: 'imageGalleryBlock',
    value: {
      fst: {
        index: 13,
        title: (
          <>
            Etiam rhoncus <span className="weight--bold">Maecenas tempus.</span>
          </>
        ),
        intro:
          'Leo eget bibendum sodales, augue velit cursus nunc, quis gravida magna mi a libero. Fusce vulputate eleifend sapien. Vestibulum purus quam, scelerisque ut, mollis sed, nonummy id, metus. Nullam accumsan lorem in dui.',
        images: new ListWithAtLeast3Items(
          List([
            {
              index: 1301,
              image: 2,
              image_alt: 'Leo eget bibendum sodales',
              image_size: '1920w',
              is_foreground: false,
              caption: 'Fusce vulputate eleifend sapien.',
              source: 'John Doe'
            },
            {
              index: 1302,
              image: 4,
              image_alt: 'Leo eget bibendum sodales',
              image_size: '1920w',
              is_foreground: false,
              caption: 'Fusce vulputate eleifend sapien.',
              source: 'John Doe'
            },
            {
              index: 1303,
              image: 2,
              image_alt: 'Leo eget bibendum sodales',
              image_size: '1280w',
              is_foreground: false,
              caption: 'Fusce vulputate eleifend sapien.',
              source: 'John Doe'
            },
            {
              index: 1304,
              image: 2,
              image_alt: 'Leo eget bibendum sodales',
              image_size: '2880w',
              is_foreground: false,
              caption: 'Fusce vulputate eleifend sapien.',
              source: 'John Doe'
            },
            {
              index: 1305,
              image: 2,
              image_alt: 'Leo eget bibendum sodales',
              image_size: '1920w',
              is_foreground: false,
              caption: '',
              source: ''
            },
            {
              index: 1306,
              image: 2,
              image_alt: 'Leo eget bibendum sodales',
              image_size: '2880w',
              is_foreground: false,
              caption: 'Fusce vulputate eleifend sapien.',
              source: 'John Doe'
            },
            {
              index: 1307,
              image: 2,
              image_alt: 'Leo eget bibendum sodales',
              image_size: '2880w',
              is_foreground: false,
              caption: '',
              source: ''
            }
          ])
        ),
        get_default_data_src: gallery_src,
        get_default_data_srcset: gallery_srcset,
        copy: {
          close: 'Close overlay',
          more: 'Open more images',
          enlarged: 'View enlarged image',
          previous: 'Previous image',
          next: 'Next image'
        },
        inview: {
          threshold: 0.25,
          triggerOnce: true
        }
      },
      snd: imageGalleryBlockClasses
    }
  }),
  custom_page_data: null
}

export const FakeCtaBlockText = (initState: CMSState<never, ExtraImages, never>) =>
  renderBlock(
    {
      kind: 'ctaBlock',
      value: {
        fst: {
          index: 400,
          title: (
            <>
              Etiam rhoncus <span className="weight--bold">Maecenas tempus.</span>
            </>
          ),
          intro:
            'Leo eget bibendum sodales, augue velit cursus nunc, quis gravida magna mi a libero. Fusce vulputate eleifend sapien. Vestibulum purus quam, scelerisque ut, mollis sed, nonummy id, metus. Nullam accumsan lorem in dui.',
          buttons: 'primary_secondary',
          primary_button: {
            is_link_external: false,
            kind: 'link',
            target: '_self',
            title: 'Luctus vitae',
            url: '/'
          },
          link_type: false,
          image: undefined,
          image_size: '360x360',
          image_alt: 'Lorem ipsum',
          display_option: 'content-width',
          get_default_data_src: get_default_data_src,
          get_default_data_srcset: get_default_data_srcset
        },
        snd: ctaBlockClasses(false)
      }
    },
    blocks_renderer<any, any, any>()
  )(initState)

export const FakeCtaBlockImage = (initState: CMSState<never, ExtraImages, never>) =>
  renderBlock(
    {
      kind: 'ctaBlock',
      value: {
        fst: {
          index: 2,
          title: (
            <>
              Etiam rhoncus <span className="weight--bold">Maecenas tempus.</span>
            </>
          ),
          intro:
            'Leo eget bibendum sodales, augue velit cursus nunc, quis gravida magna mi a libero. Fusce vulputate eleifend sapien. Vestibulum purus quam, scelerisque ut, mollis sed, nonummy id, metus. Nullam accumsan lorem in dui.',
          buttons: 'primary_secondary',
          primary_button: {
            is_link_external: false,
            kind: 'link',
            target: '_self',
            title: 'Luctus vitae',
            url: '/'
          },
          link_type: false,
          image: 3,
          image_size: '1400w',
          image_alt: 'Lorem ipsum',
          display_option: 'full-width',
          get_default_data_src: ctablock_src,
          get_default_data_srcset: ctablock_srcset
        },
        snd: ctaBlockClasses(true)
      }
    },
    blocks_renderer<any, any, any>()
  )(initState)

export const FakeDownloadBlock = (initState: CMSState<never, ExtraImages, never>) =>
  renderBlock(
    {
      kind: 'downloadBlock',
      value: {
        fst: {
          title: (
            <>
              Etiam rhoncus <span className="weight--bold">Maecenas tempus.</span>
            </>
          ),
          intro:
            'Leo eget bibendum sodales, augue velit cursus nunc, quis gravida magna mi a libero. Fusce vulputate eleifend sapien. Vestibulum purus quam, scelerisque ut, mollis sed, nonummy id, metus. Nullam accumsan lorem in dui.',
          items: [
            {
              key: '3000',
              title: 'Circlelock Combi Product folder',
              file_url: 'pdf.pdf'
            },
            {
              key: '3001',
              title: 'Circlelock Combi Product folder',
              text: 'Subtitle of Circlelock Combi Product folder',
              file_url: 'pdf.pdf'
            }
          ],
          useSVGIcons: true,
          index: 0
        },
        snd: downloadBlockClasses
      }
    },
    blocks_renderer<any, any, any>()
  )(initState)

export const FakeExpandBlock = (initState: CMSState<never, ExtraImages, never>) =>
  renderBlock(
    {
      kind: 'expandBlock',
      value: {
        fst: {
          index: 798,
          title: (
            <>
              Etiam rhoncus <span className="weight--bold">Maecenas tempus.</span>
            </>
          ),
          intro:
            'Leo eget bibendum sodales, augue velit cursus nunc, quis gravida magna mi a libero. Fusce vulputate eleifend sapien. Vestibulum purus quam, scelerisque ut, mollis sed, nonummy id, metus. Nullam accumsan lorem in dui.',
          link: {
            kind: 'link',
            is_link_external: false,
            target: '_self',
            url: '/',
            title: 'Luctus vitae'
          },
          inview: {
            threshold: 0.1,
            triggerOnce: true
          },
          items: [
            {
              title: 'Vestibulum purus quam scelerisque ut',
              key: '1',
              index: 4,
              subtitle: 'Etiam rhoncus maecenas tempus',
              text:
                'Leo eget bibendum sodales, augue velit cursus nunc, quis gravida magna mi a libero. Fusce vulputate eleifend sapien. Vestibulum purus quam, scelerisque ut, mollis sed, nonummy id, metus. Nullam accumsan lorem in dui.',
              open: false,
              useSVGIcons: true,
              blocks: List([
                {
                  kind: 'mediaBlockNested',
                  value: {
                    fst: {
                      index: 900,
                      inview: {
                        threshold: 0.1,
                        triggerOnce: true
                      },
                      items: [
                        {
                          kind: 'image',
                          caption: 'Scelerisque ut, mollis sed, nonummy id, metus.',
                          source: 'Source',
                          image: 2,
                          image_alt: 'Scelerisque ut, mollis sed, nonummy id, metus.',
                          image_option: 'content-width',
                          size: '1920w',
                          get_default_data_src: get_default_data_src,
                          get_default_data_srcset: get_default_data_srcset,
                          useCookieBar: false,
                          cookieButton: GetCookiebarButton('media'),
                          cookiePlaceholder: GetCookiebarContent('media')
                        }
                      ]
                    },
                    snd: mediaBlockNestedClasses
                  }
                }
              ])
            },
            {
              title: 'Nullam id dolor id nibh ultricies vehicula ut id elit.',
              key: '2',
              index: 5,
              subtitle: 'Etiam rhoncus maecenas tempus',
              text:
                'Leo eget bibendum sodales, augue velit cursus nunc, quis gravida magna mi a libero. Fusce vulputate eleifend sapien. Vestibulum purus quam, scelerisque ut, mollis sed, nonummy id, metus. Nullam accumsan lorem in dui.',
              open: false,
              useSVGIcons: true,
              blocks: List([
                {
                  kind: 'textBlockNested',
                  value: {
                    fst: {
                      index: 900,
                      inview: {
                        threshold: 0.1,
                        triggerOnce: true
                      },
                      text: '<p>Maecenas sed diam eget risus varius blandit sit amet non magna. Vestibulum id ligula porta felis euismod semper.</p> <ul><li>Bibendum Ligula Pharetra</li><li>Donec sed odio dui. Donec sed odio dui.</li></ul>'
                    },
                    snd: textBlockNestedClasses
                  }
                }
              ])
            },
            {
              title: 'Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.',
              key: '2',
              index: 6,
              subtitle: 'Etiam rhoncus maecenas tempus',
              text:
                'Leo eget bibendum sodales, augue velit cursus nunc, quis gravida magna mi a libero. Fusce vulputate eleifend sapien. Vestibulum purus quam, scelerisque ut, mollis sed, nonummy id, metus. Nullam accumsan lorem in dui.',
              open: false,
              useSVGIcons: true,
              blocks: List([
                {
                  kind: 'quoteBlockNested',
                  value: {
                    fst: {
                      index: 900,
                      inview: {
                        threshold: 0.1,
                        triggerOnce: true
                      },
                      text: 'Donec sed odio dui. Sed posuere consectetur est at lobortis.',
                      author: 'John Do'
                    
                    },
                    snd: quoteBlockNestedClasses
                  }
                }
              ])
            }
          ]
        },
        snd: expandBlockClasses
      }
    },
    blocks_renderer<any, any, any>()
  )(initState)

// export const FakeFeaturedBlockLeft = (initState: CMSState<never, ExtraImages, never>) =>
//   renderBlock(
//     {
//       kind: 'featuredContentBlock',
//       value: {
//         fst: {
//           index: 204,
//           block_index: 630,
//           imageLocation: 'left',
//           copy: {
//             more: 'Read more'
//           },
//           inview: {
//             threshold: 0.1,
//             triggerOnce: true
//           },
//           featuredItem: {
//             image: 2,
//             image_size: '1920w',
//             image_alt_text: 'Etiam rhoncus',
//             label: 'Etiam rhoncus',
//             title: (
//               <>
//                 Etiam rhoncus <span className="weight--bold">Maecenas tempus.</span>
//               </>
//             ),
//             subtitle: 'Nullam accumsan lorem in dui',
//             intro:
//               'Leo eget bibendum sodales, augue velit cursus nunc, quis gravida magna mi a libero. Fusce vulputate eleifend sapien. Vestibulum purus quam, scelerisque ut, mollis sed, nonummy id, metus. Nullam accumsan lorem in dui. Cras ultricies mi eu turpis hendrerit fringilla.',
//             link: {
//               kind: 'link',
//               is_link_external: false,
//               target: '_self',
//               url: '/',
//               title: 'Luctus vitae'
//             },
//             link_label: 'Luctus vitae',
//             get_default_data_src: featuredblock_src,
//             get_default_data_srcset: featuredblock_srcset
//           }
//         },
//         snd: featuredContentClasses('left')
//       }
//     },
//     blocks_renderer<any, any, any>()
//   )(initState)

// export const FakeFeaturedBlockRight = (initState: CMSState<never, ExtraImages, never>) =>
//   renderBlock(
//     {
//       kind: 'featuredContentBlock',
//       value: {
//         fst: {
//           index: 205,
//           block_index: 631,
//           imageLocation: 'right',
//           copy: {
//             more: 'Read more'
//           },
//           inview: {
//             threshold: 0.1,
//             triggerOnce: true
//           },
//           featuredItem: {
//             image: 2,
//             image_size: '1920w',
//             image_alt_text: 'Etiam rhoncus',
//             label: 'Etiam rhoncus',
//             title: (
//               <>
//                 Etiam rhoncus <span className="weight--bold">Maecenas tempus.</span>
//               </>
//             ),
//             subtitle: 'Nullam accumsan lorem in dui',
//             intro:
//               'Leo eget bibendum sodales, augue velit cursus nunc, quis gravida magna mi a libero. Fusce vulputate eleifend sapien. Vestibulum purus quam, scelerisque ut, mollis sed, nonummy id, metus. Nullam accumsan lorem in dui. Cras ultricies mi eu turpis hendrerit fringilla.',
//             link: {
//               kind: 'link',
//               is_link_external: false,
//               target: '_self',
//               url: '/',
//               title: 'Luctus vitae'
//             },
//             link_label: 'Luctus vitae',
//             get_default_data_src: featuredblock_src,
//             get_default_data_srcset: featuredblock_srcset
//           }
//         },
//         snd: featuredContentClasses('right')
//       }
//     },
//     blocks_renderer<any, any, any>()
//   )(initState)

export const FakeImageGalleryBlock = (initState: CMSState<never, ExtraImages, never>) =>
  stateful<CMSState<never, ExtraImages, never>>()(
    // @ts-ignore
    (s) => renderBlock(s.blocks.get(13) as any, blocks_renderer<never, never>())(s).map((a) => a(s))
  )(initState)

export const FakeLinkBlock = (initState: CMSState<never, ExtraImages, never>) =>
  renderBlock(
    {
      kind: 'linkBlock',
      value: {
        fst: {
          title: (
            <>
              Etiam rhoncus <span className="weight--bold">Maecenas tempus.</span>
            </>
          ),
          index: 5000,
          useSVGIcons: false,
          intro:
            'Leo eget bibendum sodales, augue velit cursus nunc, quis gravida magna mi a libero. Fusce vulputate eleifend sapien. Vestibulum purus quam, scelerisque ut, mollis sed, nonummy id, metus. Nullam accumsan lorem in dui.',
          items: [
            {
              key: '1902-1',
              title: 'Leo eget bibendum sodales',
              url: '/',
              target: '_self',
              is_link_external: true
            },
            {
              key: '1902-2',
              title: 'Augue velit cursus nunc',
              url: '/',
              target: '_blank',
              is_link_external: true
            },
            {
              key: '1902-3',
              title: 'Quis gravida magna',
              text: 'Augue velit cursus nunc',
              url: '/',
              target: '_self',
              is_link_external: true
            },
            {
              key: '1902-4',
              title: 'Mi a libero',
              text: 'Augue velit cursus nunc',
              url: '/',
              target: '_self',
              is_link_external: true
            }
          ]
        },
        snd: linkListBlockClasses
      }
    },
    blocks_renderer<any, any, any>()
  )(initState)

export const FakeLinkGridTextBlock = (initState: CMSState<never, ExtraImages, never>) =>
  renderBlock(
    {
      kind: 'linkGridBlock',
      value: {
        fst: {
          index: 800,
          title: (
            <>
              Etiam rhoncus <span className="weight--bold">Maecenas tempus.</span>
            </>
          ),
          intro:
            'Leo eget bibendum sodales, augue velit cursus nunc, quis gravida magna mi a libero. Fusce vulputate eleifend sapien. Vestibulum purus quam, scelerisque ut, mollis sed, nonummy id, metus. Nullam accumsan lorem in dui.',
          items: [
            {
              image: 2,
              image_size: '360x360',
              image_alt: '',
              title: 'Donec vitae',
              label: 'Lorem ipsum',
              intro: 'Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus. Cras mattis consectetur purus sit amet fermentum.',
              show_image: 'no'
            },
            {
              image: 2,
              image_size: '360x360',
              image_alt: '',
              title: 'Donec vitae Pharetra Nibh Cursus Quam Condimentum',
              label: 'Lorem ipsum',
              intro: 'Consectetuer adipiscing elit.',
              link: {
                is_link_external: false,
                kind: 'link',
                target: '_self',
                title: 'Luctus vitae',
                url: '/'
              },
              show_image: 'no'
            },
            {
              image: 2,
              image_size: '360x360',
              image_alt: '',
              title: 'Donec vitae',
              label: 'Lorem ipsum',
              intro: 'Consectetuer adipiscing elit. Morbi leo risus, porta ac consectetur ac, vestibulum at eros.',
              link: {
                is_link_external: false,
                kind: 'link',
                target: '_self',
                title: 'Luctus vitae',
                url: ''
              },
              show_image: 'no'
            },
            {
              image: 2,
              image_size: '360x360',
              image_alt: '',
              title: 'Donec vitae',
              intro: 'Consectetuer adipiscing elit.',
              link: {
                is_link_external: false,
                kind: 'link',
                target: '_self',
                title: 'Luctus vitae',
                url: '/'
              },
              show_image: 'no'
            },
            {
              image: 2,
              image_size: '360x360',
              image_alt: '',
              title: 'Donec vitae',
              intro: 'Consectetuer adipiscing elit.',
              link: {
                is_link_external: false,
                kind: 'link',
                target: '_self',
                title: 'Luctus vitae',
                url: ''
              },
              show_image: 'no'
            },
            {
              image: 2,
              image_size: '360x360',
              image_alt: '',
              title: 'Donec vitae',
              intro: 'Consectetuer adipiscing elit.',
              link: {
                is_link_external: false,
                kind: 'link',
                target: '_self',
                title: 'Luctus vitae',
                url: '/'
              },
              show_image: 'no'
            }
          ],
          link: {
            is_link_external: false,
            kind: 'link',
            target: '_self',
            title: 'Luctus vitae',
            url: '/'
          },
          show_image: 'no',
          get_default_data_src: linkgridblock_src,
          get_default_data_srcset: linkgridblock_srcset
        },
        snd: linkGridBlockPlainClasses
      }
    },
    blocks_renderer<any, any, any>()
  )(initState)

export const FakeLinkGridTextImageBlock = (initState: CMSState<never, ExtraImages, never>) =>
  renderBlock(
    {
      kind: 'linkGridBlock',
      value: {
        fst: {
          index: 801,
          title: (
            <>
              Etiam rhoncus <span className="weight--bold">Maecenas tempus.</span>
            </>
          ),
          intro:
            'Leo eget bibendum sodales, augue velit cursus nunc, quis gravida magna mi a libero. Fusce vulputate eleifend sapien. Vestibulum purus quam, scelerisque ut, mollis sed, nonummy id, metus. Nullam accumsan lorem in dui.',
          items: [
            {
              image: 2,
              image_size: '360x360',
              image_alt: '',
              title: 'Donec vitae  Parturient Egestas Fusce Ridiculus Vehicula',
              label: 'Lorem ipsum',
              intro: 'Consectetuer adipiscing elit.',
              show_image: 'yes'
            },
            {
              image: 2,
              image_size: '360x360',
              image_alt: '',
              title: 'Donec vitae',
              label: 'Lorem ipsum',
              intro: 'Consectetuer adipiscing elit. Curabitur blandit tempus porttitor. Aenean lacinia bibendum nulla sed consectetur.',
              link: {
                is_link_external: false,
                kind: 'link',
                target: '_self',
                title: 'Luctus vitae',
                url: '/'
              },
              show_image: 'yes'
            },
            {
              image: 2,
              image_size: '360x360',
              image_alt: '',
              title: 'Etiam porta sem malesuada magna mollis euismod.',
              label: 'Lorem ipsum',
              intro: 'Consectetuer adipiscing elit. Nulla vitae elit libero, a pharetra augue. Aenean lacinia bibendum nulla sed consectetur.',
              link: {
                is_link_external: false,
                kind: 'link',
                target: '_self',
                title: 'Luctus vitae',
                url: ''
              },
              show_image: 'yes'
            },
            {
              image: 2,
              image_size: '360x360',
              image_alt: '',
              title: 'Donec vitae',
              intro: 'Consectetuer adipiscing elit.',
              link: {
                is_link_external: false,
                kind: 'link',
                target: '_self',
                title: 'Luctus vitae',
                url: '/'
              },
              show_image: 'yes'
            },
            {
              image: 2,
              image_size: '360x360',
              image_alt: '',
              title: 'Donec vitae',
              intro: 'Consectetuer adipiscing elit.',
              link: {
                is_link_external: false,
                kind: 'link',
                target: '_self',
                title: 'Luctus vitae',
                url: ''
              },
              show_image: 'yes'
            },
            {
              image: 2,
              image_size: '360x360',
              image_alt: '',
              title: 'Donec vitae',
              intro: 'Consectetuer adipiscing elit.',
              link: {
                is_link_external: false,
                kind: 'link',
                target: '_self',
                title: 'Luctus vitae',
                url: '/'
              },
              show_image: 'yes'
            }
          ],
          link: {
            is_link_external: false,
            kind: 'link',
            target: '_self',
            title: 'Luctus vitae',
            url: '/'
          },
          show_image: 'yes',
          get_default_data_src: get_default_data_src,
          get_default_data_srcset: get_default_data_srcset
        },
        snd: linkGridBlockClasses
      }
    },
    blocks_renderer<any, any, any>()
  )(initState)

export const FakeLinkGridImageBlock = (initState: CMSState<never, ExtraImages, never>) =>
  renderBlock(
    {
      kind: 'linkGridBlock',
      value: {
        fst: {
          index: 802,
          title: (
            <>
              Etiam rhoncus <span className="weight--bold">Maecenas tempus.</span>
            </>
          ),
          items: [
            {
              image: 2,
              image_size: '360x360',
              image_alt: '',
              title: '',
              label: '',
              intro: '',
              link: {
                is_link_external: false,
                kind: 'link',
                target: '_self',
                title: '',
                url: ''
              },
              show_image: 'yes'
            },
            {
              image: 2,
              image_size: '360x360',
              image_alt: '',
              title: '',
              label: '',
              intro: '',
              link: {
                is_link_external: false,
                kind: 'link',
                target: '_self',
                title: '',
                url: ''
              },
              show_image: 'yes'
            },
            {
              image: 2,
              image_size: '360x360',
              image_alt: '',
              title: '',
              label: '',
              intro: '',
              link: {
                is_link_external: false,
                kind: 'link',
                target: '_self',
                title: '',
                url: ''
              },
              show_image: 'yes'
            }
          ],
          show_image: 'yes',
          get_default_data_src: get_default_data_src,
          get_default_data_srcset: get_default_data_srcset
        },
        snd: linkGridBlockClasses
      }
    },
    blocks_renderer<any, any, any>()
  )(initState)

export const FakeMediaBlockImages = (initState: CMSState<never, ExtraImages, never>) =>
  any()([
    renderBlock(
      {
        kind: 'mediaBlock',
        value: {
          fst: {
            index: 900,
            title: (
              <>
                Etiam rhoncus <span className="weight--bold">Maecenas tempus.</span>
              </>
            ),
            intro:
              'Leo eget bibendum sodales, augue velit cursus nunc, quis gravida magna mi a libero. Fusce vulputate eleifend sapien. Vestibulum purus quam, scelerisque ut, mollis sed, nonummy id, metus. Nullam accumsan lorem in dui.',
            items: [
              {
                caption: 'Content-width vestibulum purus quam, scelerisque ut, mollis sed, nonummy id, metus.',
                source: 'Source',
                image: 2,
                image_alt: 'Content-width vestibulum purus quam, scelerisque ut, mollis sed, nonummy id, metus.',
                image_option: 'content-width',
                size: '640w',
                kind_media: 'image',
                video: {
                  allowFullScreen: true,
                  frameBorder: '0',
                  height: '315',
                  width: '420',
                  url: 'https://www.youtube.com/watch?v=GlhzdGx4ldE',
                  id: '200',
                  type: 'video'
                },
                get_default_data_src: get_default_data_src,
                get_default_data_srcset: get_default_data_srcset,
                useCookieBar: false,
                cookieButton: GetCookiebarButton('media'),
                cookiePlaceholder: GetCookiebarContent('media')
              },
              {
                caption: 'Full-width vestibulum purus quam, scelerisque ut, mollis sed, nonummy id, metus.',
                source: 'Source',
                image: 2,
                image_alt: 'Full-width vestibulum purus quam, scelerisque ut, mollis sed, nonummy id, metus.',
                image_option: 'full-width',
                size: '1920w',
                kind_media: 'image',
                video: {
                  allowFullScreen: true,
                  frameBorder: '0',
                  height: '315',
                  width: '420',
                  url: 'https://www.youtube.com/watch?v=GlhzdGx4ldE',
                  id: '200',
                  type: 'video'
                },
                get_default_data_src: get_default_data_src,
                get_default_data_srcset: get_default_data_srcset,
                useCookieBar: false,
                cookieButton: GetCookiebarButton('media'),
                cookiePlaceholder: GetCookiebarContent('media')
              }
            ]
          },
          snd: mediaBlockClasses
        }
      },
      blocks_renderer<any, any, any>()
    )(initState),
    renderBlock(
      {
        kind: 'mediaBlock',
        value: {
          fst: {
            index: 901,
            items: [
              {
                caption: 'Content-width vestibulum purus quam, scelerisque ut, mollis sed, nonummy id, metus.',
                source: 'Source',
                image: 2,
                image_alt: 'Content-width vestibulum purus quam, scelerisque ut, mollis sed, nonummy id, metus.',
                image_option: 'content-width',
                size: '1920w',
                kind_media: 'video',
                video: {
                  allowFullScreen: true,
                  frameBorder: '0',
                  height: '315',
                  width: '420',
                  url: 'https://www.youtube.com/watch?v=GlhzdGx4ldE',
                  id: '200',
                  type: 'video'
                },
                get_default_data_src: get_default_data_src,
                get_default_data_srcset: get_default_data_srcset,
                useCookieBar: false,
                cookieButton: GetCookiebarButton('media'),
                cookiePlaceholder: GetCookiebarContent('media')
              },
              {
                caption: 'Full-width vestibulum purus quam, scelerisque ut, mollis sed, nonummy id, metus.',
                source: 'Source',
                image: 2,
                image_alt: 'Full-width vestibulum purus quam, scelerisque ut, mollis sed, nonummy id, metus.',
                image_option: 'full-width',
                size: '1920w',
                kind_media: 'video',
                video: {
                  allowFullScreen: true,
                  frameBorder: '0',
                  height: '315',
                  width: '420',
                  url: 'https://www.youtube.com/watch?v=GlhzdGx4ldE',
                  id: '200',
                  type: 'video'
                },
                get_default_data_src: get_default_data_src,
                get_default_data_srcset: get_default_data_srcset,
                useCookieBar: true,
                cookieButton: GetCookiebarButton('media'),
                cookiePlaceholder: GetCookiebarContent('media')
              }
            ]
          },
          snd: mediaBlockClasses
        }
      },
      blocks_renderer<any, any, any>()
    )(initState)
  ])

export const FakeTextBlock = (initState: CMSState<never, ExtraImages, never>) =>
  renderBlock(
    {
      kind: 'textBlock',
      value: {
        fst: {
          title: (
            <>
              Etiam rhoncus <span className="weight--bold">Maecenas tempus.</span>
            </>
          ),
          text: `
            <p><b>Tellus eget condimentum rhoncus, <a href='/'>sem quam semper libero</a>, sit amet
            adipiscing sem neque sed ipsum. Nam quam nunc, blandit vel, luctus pulvinar, hendrerit id, lorem.
            Maecenas nec odio et ante <em>tincidunt tempus</em>. Donec vitae sapien ut libero venenatis faucibus.
            Nullam quis ante. Etiam sit amet orci eget eros faucibus tincidunt.</b></p>
            <h3>Vestibulum ante itae sapien ut libero</h3>
            <p>Leo eget bibendum sodales, augue velit cursus nunc, quis gravida magna mi a libero. Fusce vulputate eleifend sapien. Vestibulum purus quam, scelerisque ut, mollis sed, nonummy id, metus. Nullam accumsan lorem in dui.
            Cras ultricies mi eu turpis hendrerit fringilla.</p>
            <ul>
              <li>Morbi leo risus, porta ac consectetur ac, vestibulum at eros.</li>
              <li>Aenean lacinia bibendum nulla sed consectetur.</li>
              <li>Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.
                <ul>
                  <li>Integer consequat sapien a lectus gravida euismod.</li>
                  <li>Integer consequat sapien a lectus gravida euismod.</li>
                </ul>
              </li>
              <li>Nullam quis risus eget urna mollis ornare vel eu leo.</li>
            </ul>
            <h4>A pharetra augue itae sapien ut libero venenatis</h4>
            <p>Consectetuer adipiscing elit. Integer consequat sapien a lectus gravida euismod. Sed vitae nisl non odio viverra accumsan. Curabitur nisi neque, egestas sed, vulputate sit amet, luctus vitae, dolor. Cras lacus massa, sagittis ut, volutpat consequat, interdum a, nulla</p>
            <ol>
              <li>Morbi leo risus, porta ac consectetur ac, vestibulum at eros.</li>
              <li>Aenean lacinia bibendum nulla sed consectetur.</li>
              <li>Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.
                <ol>
                  <li>Morbi leo risus, porta ac consectetur ac, vestibulum at eros.</li>
                  <li>Aenean lacinia bibendum nulla sed consectetur.</li>
                </ol>
              </li>
              <li>Nullam quis risus eget urna mollis ornare vel eu leo.</li>
            </ol>
            <h5>Tincidunt tempus itae sapien ut</h5>
            <p>Etiam rhoncus. Maecenas tempus, tellus eget condimentum rhoncus, <a href='/'>sem quam semper libero</a>, sit <b>amet</b> adipiscing sem neque sed ipsum. Nam quam nunc, blandit vel, luctus pulvinar, hendrerit id, lorem.
            Maecenas nec odio et ante <em>tincidunt tempus</em>.</p>
            <h6>Hendrerit fringilla quis risus eget urna mollis ornare vel</h6>
            <p>Leo eget bibendum sodales, augue velit cursus nunc, quis gravida magna mi a libero. Fusce vulputate eleifend sapien. Vestibulum purus quam, scelerisque ut, mollis sed, nonummy id, metus. Nullam accumsan lorem in dui. Cras ultricies mi eu turpis hendrerit fringilla. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; In ac dui quis mi consectetuer lacinia.</p>
          `,
          primary_button: {
            is_link_external: false,
            kind: 'link',
            target: '_self',
            title: 'Luctus vitae',
            url: '/'
          },
          link: {
            is_link_external: false,
            kind: 'link',
            target: '_self',
            title: 'Donec vitae',
            url: '/'
          },
          link_type: false,
          index: 0
        },
        snd: textBlockClasses
      }
    },
    blocks_renderer<any, any, any>()
  )(initState)

export const FakeTextImageLeftBlock = (initState: CMSState<never, ExtraImages, never>) =>
  renderBlock(
    {
      kind: 'textImageBlock',
      value: {
        fst: {
          index: 1,
          imageLocation: "left",

          title: (
            <>
              Etiam rhoncus Maecenas tempus.
            </>
          ),
          text: "Nullam quis risus eget urna mollis ornare vel eu leo. Aenean eu leo quam. Pellentesque ornare sem lacinia quam venenatis vestibulum.",
          image: 2,
          image_alt_text: '',
          image_size: '640w',
          get_default_data_src: textimageblock_src,
          get_default_data_srcset: textimageblock_srcset,
          primary_button: {
            is_link_external: false,
            kind: 'link',
            target: '_self',
            title: 'Luctus vitae',
            url: '/'
          },
          secondary_button: {
            is_link_external: false,
            kind: 'link',
            target: '_self',
            title: 'Quam Dapibus uam Dapibus',
            url: '/'
          },
          link_type: false
        },
        snd: textImageClasses("left")
      }
    },
    blocks_renderer<any, any, any>()
  )(initState)

export const FakeTextImageRightBlock = (initState: CMSState<never, ExtraImages, never>) =>
  renderBlock(
    {
      kind: 'textImageBlock',
      value: {
        fst: {
          index: 1,
          imageLocation: "right",

          title: (
            <>
              Etiam rhoncus Maecenas tempus.
            </>
          ),
          text: "Nullam quis risus eget urna mollis ornare vel eu leo. Aenean eu leo quam. Pellentesque ornare sem lacinia quam venenatis vestibulum.",
          image: 2,
          image_alt_text: '',
          image_size: '640w',
          get_default_data_src: featuredblock_src,
          get_default_data_srcset: featuredblock_srcset,
          primary_button: {
            is_link_external: false,
            kind: 'link',
            target: '_self',
            title: 'Luctus vitae',
            url: '/'
          },
          secondary_button: {
            is_link_external: false,
            kind: 'link',
            target: '_self',
            title: 'Quam Dapibus uam Dapibus',
            url: '/'
          },
          link_type: false
        },
        snd: textImageClasses("right")
      }
    },
    blocks_renderer<any, any, any>()
  )(initState)

export const FakeQuoteBlockText = (initState: CMSState<never, ExtraImages, never>) =>
  renderBlock(
    {
      kind: 'quoteBlock',
      value: {
        fst: {
          index: 5,
          text:
            'Consectetuer adipiscing elit. Integer consequat sapien a lectus gravida euismod. Sed vitae nisl non odio viverra accumsan.',
          author: 'Etiam rhoncus. Maecenas tempus...',
          link: {
            kind: 'link',
            is_link_external: false,
            target: '_self',
            url: '#',
            title: 'Luctus vitae'
          },
          image: 2,
          image_alt: '',
          image_size: '640x360',
          get_default_data_src: quoteblock_src,
          get_default_data_srcset: quoteblock_srcset
        },
        snd: quoteBlockClasses(false)
      }
    },
    blocks_renderer<any, any, any>()
  )(initState)

export const FakeQuoteBlockTextImage = (initState: CMSState<never, ExtraImages, never>) =>
  renderBlock(
    {
      kind: 'quoteBlock',
      value: {
        fst: {
          index: 5,
          text:
            'Consectetuer adipiscing elit. Integer consequat sapien a lectus gravida euismod. Sed vitae nisl non odio viverra accumsan.',
          author: 'Etiam rhoncus. Maecenas tempus...',
          image: 2,
          image_alt: '',
          image_size: '640x360',
          get_default_data_src: quoteblock_src,
          get_default_data_srcset: quoteblock_srcset
        },
        snd: quoteBlockClasses(true)
      }
    },
    blocks_renderer<any, any, any>()
  )(initState)

  export const FakeTimelineLeftBlock = (initState: CMSState<never, ExtraImages, never>) => (
           <li className="block__item item">
             <div className="item__inner">
               <div className="item__content">
                 <header className="item__header">
                   <h3 className="item__title title--m">year X</h3>
                 </header>
                 <div className="item__text">
                   <div className="item__intro">
                     Maecenas faucibus mollis interdum. Vestibulum id ligula porta felis euismod semper. Cum sociis
                     natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Integer posuere erat a
                     ante venenatis dapibus posuere velit aliquet. Nullam quis risus eget urna mollis ornare vel eu leo.
                     Donec sed odio dui.
                   </div>
                 </div>
               </div>
               <div className="item__visual">
                 <img
                   src="/styleguide/images/640x360.png"
                   data-src="/styleguide/images/640x360.png"
                   data-srcset="/styleguide/images/640x360.png 640w,/styleguide/images/1280x720.png 1280w,/styleguide/images/1920x1080.png 1920w,/styleguide/images/2880x1620.png 2880w"
                   data-sizes="auto"
                   className="item__image"
                   alt=""
                 />
               </div>
             </div>
           </li>
         )

export const FakeTimelineRightBlock = (initState: CMSState<never, ExtraImages, never>) =>(
  <li className="block__item item item--right">
    <div className="item__inner">
      <div className="item__content">
        <header className="item__header">
          <h3 className="item__title title--m">year Y</h3>
        </header>
        <div className="item__text">
          <div className="item__intro">
            Maecenas faucibus mollis interdum. Vestibulum id ligula porta felis euismod semper. Cum sociis
            natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Integer posuere erat a
            ante venenatis dapibus posuere velit aliquet. Nullam quis risus eget urna mollis ornare vel eu leo.
            Donec sed odio dui.
          </div>
        </div>
      </div>
      <div className="item__visual">
        <img
          src="/styleguide/images/640x360.png"
          data-src="/styleguide/images/640x360.png"
          data-srcset="/styleguide/images/640x360.png 640w,/styleguide/images/1280x720.png 1280w,/styleguide/images/1920x1080.png 1920w,/styleguide/images/2880x1620.png 2880w"
          data-sizes="auto"
          className="item__image"
          alt=""
        />
      </div>
    </div>
  </li>
)

export const FakeStoriesBlock = (initState: CMSState<never, ExtraImages, never>) => (
  <>
  <li className="grid__item">
    <article className="grid__article">
      <a className="grid__link" href="#">
        <div className="grid__content">
          <header className="grid__header">
            <span className="grid__label block__label label--m">06 august 2019</span>
            <h3 className="grid__title title--xs">Donec vitae Parturient Egestas Fusce Ridiculus Vehicula</h3>
          </header>
          <span className="grid__fauxlink link link--arrow">Luctus vitae</span>
        </div>
        <div className="grid__visual container fit-object">
          <img
            src="/styleguide/images/360x360.png"
            data-srcset=""
            data-sizes="auto"
            className="grid__image lazyautosizes lazyloaded"
            alt=""
            sizes="420px"
          />
        </div>
      </a>
    </article>
  </li>
  <li className="grid__item">
    <article className="grid__article">
      <div className="grid__link">
        <div className="grid__content">
          <header className="grid__header">
            <span className="grid__label block__label label--m">06 august 2019</span>
            <h3 className="grid__title title--xs">Maecenas faucibus mollis interdum</h3>
          </header>
        </div>
        <div className="grid__visual container fit-object">
          <img
            src="/styleguide/images/360x360.png"
            data-srcset=""
            data-sizes="auto"
            className="grid__image lazyautosizes lazyloaded"
            alt=""
            sizes="420px"
          />
        </div>
      </div>
    </article>
  </li>
  <li className="grid__item">
    <article className="grid__article">
      <a className="grid__link" href="#">
        <div className="grid__content">
          <header className="grid__header">
            <span className="grid__label block__label label--m">06 august 2019</span>
            <h3 className="grid__title title--xs">Nullam id dolor id nibh ultricies vehicula ut id elit. Donec ullamcorper nulla non metus auctor fringilla</h3>
          </header>
          <span className="grid__fauxlink link link--arrow">Luctus vitae</span>
        </div>
        <div className="grid__visual container fit-object">
          <img
            src="/styleguide/images/360x360.png"
            data-srcset=""
            data-sizes="auto"
            className="grid__image lazyautosizes lazyloaded"
            alt=""
            sizes="420px"
          />
        </div>
      </a>
    </article>
  </li>
  </>
)

export const FakePressReleaseBlock = (initState: CMSState<never, ExtraImages, never>) => (
  <>
  <li className="grid__item">
    <article className="grid__article">
      <a className="grid__link" href="#">
        <div className="grid__content">
          <header className="grid__header">
            <span className="grid__label block__label label--m">07 august 2019</span>
            <h3 className="grid__title title--xs">Donec vitae Parturient Egestas Fusce Ridiculus Vehicula</h3>
          </header>
          <span className="grid__fauxlink link link--arrow">Luctus vitae</span>
        </div>
      </a>
    </article>
  </li>
  <li className="grid__item">
    <article className="grid__article">
      <div className="grid__link">
        <div className="grid__content">
          <header className="grid__header">
            <span className="grid__label block__label label--m">08 august 2019</span>
            <h3 className="grid__title title--xs">Maecenas faucibus mollis interdum</h3>
          </header>
        </div>
      </div>
    </article>
  </li>
  <li className="grid__item">
    <article className="grid__article">
      <a className="grid__link" href="#">
        <div className="grid__content">
          <header className="grid__header">
            <span className="grid__label block__label label--m">09 august 2019</span>
            <h3 className="grid__title title--xs">Nullam id dolor id nibh ultricies vehicula ut id elit. Donec ullamcorper nulla non metus auctor fringilla</h3>
          </header>
          <span className="grid__fauxlink link link--arrow">Luctus vitae</span>
        </div>
      </a>
    </article>
  </li>
  </>
)